import { BadgeType } from '@grays-npm/component-library';
import { ListingType } from '../types/ListingType';

export function formatBadgeType(type: ListingType): BadgeType {
  switch (type) {
    case 'referred':
    case 'auction':
      return 'primary';
  }
}
